export default __webpack_public_path__ + "static/media/jwavesblog-alpha.6aa26d91.png";